/**
 * Plate carrier. The heaviest protection in the game and the largest target on a body, which is the
 * trade the weight limit exists to make you feel.
 */

import type { ArmorItem } from '@/sim/items/itemContract';

export const PLATE_CARRIER = {
  id: 'plateCarrier',
  kind: 'armor',
  label: 'Plate carrier',
  description:
    'Two ceramic plates and a lot of webbing. Halcyon rated it for everything made before.',
  rarity: 'rare',
  weightKg: 6.5,
  stackLimit: 1,
  equip: {
    slots: ['torso'],
    statDeltas: { agility: -1 },
    armor: { threshold: 8, rating: 45 },
    damageModifiers: [],
  },
} as const satisfies ArmorItem;
